import React from 'react'

const FullScreenLoader = (props) => {

	return (
		<div className="full-screen-loader">
			<img src="/images/icons/spinner.svg" />
		</div>
	)
}

export default React.memo(FullScreenLoader)
